/**
 * The TV link, fetched because it carries the per-session display token. In the kit
 * because a game must not know what a `displayToken` is. The token admits a display but
 * does not let it drive the game; that is `core.displayCanDrive`, toggled separately.
 */

import { useEffect, useState } from 'react';
import { api } from '../lib/api';

export interface TvLinkProps {
  /** The session code. The token is fetched, never derived from this. */
  code: string;
}

export function TvLink({ code }: TvLinkProps) {
  const [url, setUrl] = useState<string | null>(null);

  useEffect(() => {
    let live = true;
    api
      .getDisplayLink(code)
      .then((res) => {
        if (live) setUrl(res.displayUrl);
      })
      .catch(() => {
        // Deliberately silent: a toast on mount for a link nobody asked for is noise.
      });
    return () => {
      live = false;
    };
  }, [code]);

  if (!url) return null;

  return (
    <span className="tv-link">
      <a className="btn btn-sm" href={url} target="_blank" rel="noreferrer">
        TV view ↗
      </a>
    </span>
  );
}
